import React from 'react';
import {motion} from 'framer-motion';
import {RefreshIcon} from '../../UI/Icons';
import styled from 'styled-components';
import {tabletWidth} from '../../mixins';


const StyledButton = styled(motion.button)`
  cursor: pointer;
  width: 56px;
  height: 56px;
  padding: 0;
  border: none;
  background-color: transparent;
  border-radius: 50%;
  box-shadow: 2px 4px 8px rgba(0, 0, 0, 0.08), 16px 16px 16px rgba(97, 119, 122, 0.08);
  position: absolute;
  top: 130px;
  right: 24px;
  z-index: 1500;
  
  @media screen and (max-width: ${tabletWidth}) and (orientation: portrait)  {
    right: unset;
    top: 16px;
    left: 6px;
  }
  
  @media screen and (max-width: ${tabletWidth}) and (orientation: landscape) {
    right: 6px;
    top: 90px;
  }
 
`

const RefreshButton = ({onDataRefreshClick}) => {


    return (
        <StyledButton onClick={onDataRefreshClick}
            whileHover={{scale: 1.1}}
            whileTap={{scale: 0.9}}
            id='continue-button'>
            {RefreshIcon}
        </StyledButton>
    );
}

export default RefreshButton;